import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import TalentForm from '../components/UI/TalentForm';
import useFormPersistence from '../hooks/useFormPersistence';

const TalentFormPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  // Form persistence - clear on success
  const STORAGE_KEY = 'talentFormDraft';
  const { clearStorage } = useFormPersistence(STORAGE_KEY, false);

  const handleSubmit = async (talentData) => {
    // Устанавливаем auth_user_id только если он не был выбран в форме
    if (!talentData.auth_user_id) {
      talentData.auth_user_id = null;
    }

    // Используем API для создания таланта
    const { talents } = await import('../services/apiService');
    const response = await talents.createTalent(talentData);

    if (response && response.data) {
      // Возвращаем данные созданного таланта для загрузки временных файлов
      // Редирект будет выполнен в TalentForm после загрузки медиа
      return response;
    } else {
      throw new Error('Invalid response structure');
    }
  };

  const handleCancel = () => {
    navigate('/talents');
  };

  const handleSuccess = (talentId) => {
    // Clear localStorage after successful creation
    clearStorage();
    // После успешного создания таланта и загрузки медиа выполняем редирект
    if (talentId) {
      navigate(`/talents/${talentId}`);
    }
  };

  return (
    <>
      <title>New Talent | Talent Service</title>
      <TalentForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        onSuccess={handleSuccess}
        title="Create Talent"
        submitText="Create"
        showHeader={true}
        isModal={false}
      />
    </>
  );
};

export default TalentFormPage;